// M10-14277: attachment API versioning is signalled with `version=v2` as a QUERY PARAM
// (NOT a request header) so it never joins the CORS preflight `Access-Control-Request-Headers`
// — which broke on API Gateways whose Access-Control-Allow-Headers is a fixed list.
//
// `version=v2` => backend serves pre-signed attachment URLs; absent => non-expiring public URLs.
// Scope it to ONLY the 14277 read/upload endpoints. The corp patterns are deliberately PRECISE:
// the cda `/add` + `/counter/request/edit` + `/status/update` and productRequest `/edit` routes
// already use `?version=v2` to switch V2 *business logic*, so we must never match those here.

const ATTACHMENT_VERSIONED_PATTERNS = [
  'counter/request/details', // CDA counter-request detail (GET) — not /add, /edit, /status/update
  'attachmentproofs', // counter attachment proofs (GET)
  'getadditionalattachements', // counter additional attachments (GET)
  'productrequest/details', // PReq draft lists (GET) — /details, /details/id, /details/all; not /edit, /status
  'upload-file', // CDA / counter / feedback attachment uploads (POST)
  'api/v1/report', // corp report list (GET)
  'upload/csv', // corp invalid-products CSV export (POST) — response uploaded_url
  // NOTE: no OMS endpoints here — OMS stores bare S3 keys and pre-signs on demand via its
  // get-file endpoints (the prod contract since Jan 2025); it has no version-gated reads.
];

/** True when this request hits a 14277 version-gated attachment endpoint. */
export function isAttachmentVersionedRequest(config: { baseURL?: string; url?: string }): boolean {
  const full = `${config.baseURL || ''}${config.url || ''}`.toLowerCase();
  if (full.includes('version=')) return false; // a caller already set its own version
  return ATTACHMENT_VERSIONED_PATTERNS.some((p) => full.includes(p));
}
